import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

import '../styles/nav.scss';

const Nav = () => {
    
    const [navOpen, setNavOpen] = useState(false);
    
    const location = useLocation();
    const pathAfterDomain = location.pathname;
    console.log(pathAfterDomain);

    return (
        <>
            <nav className={`nav-container ${pathAfterDomain === '/' && 'nav-fixed'}`}>
                <div className="nav-platforms">
                    <img src={`${process.env.PUBLIC_URL}/img/footer/nsw.svg`}className="nsw" alt="Nintendo Switch" />
                    <img src={`${process.env.PUBLIC_URL}/img/footer/ps45.png`} className='ps' alt="Playstation 4 & Playstation 5" />
                </div>
                <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/'>Top</NavLink>
                <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/character'>Character</NavLink>
                <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/system'>System</NavLink>
                {
                    /*         
                        <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/product'>Product</NavLink>
                    */
                }
            </nav>
            <button className={`nav-menu-button ${navOpen ? 'nav-menu-button_open' : 'nav-menu-button_closed'}`}
                onClick={()=>setNavOpen(!navOpen)}
            >
                <div className="hamburger-line line-1" />
                <div className="hamburger-line line-2" />                
                <div className="hamburger-line line-3" />
            </button>
            <nav className={`mobile-nav  ${navOpen ? 'mobile-nav_open' : 'mobile-nav_closed'}`}>
                <div className="nav-mobile-wrapper">
                    <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/' onClick={()=>setNavOpen(!navOpen)}>Top</NavLink>
                    <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/character' onClick={()=>setNavOpen(!navOpen)}>Character</NavLink>
                    <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/system' onClick={()=>setNavOpen(!navOpen)}>System</NavLink>
                    {
                        /*         
                            <NavLink className={({ isActive }) => (isActive ? 'nav-link nav-active' : 'nav-link')} to='/product'>Product</NavLink>
                        */
                    }
                </div>    
            </nav>
        </>
    )
}

export default Nav;